/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Sex_LongInputs */

const en_us2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength reference tables differ, and the first-week loads come from them.`)
};

const pt_br2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tabelas de referência de força diferem, e as cargas da primeira semana vêm delas.`)
};

const es_419_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las tablas de referencia de fuerza difieren, y las cargas de la primera semana salen de ellas.`)
};

const pt_pt2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tabelas de referência de força diferem, e as cargas da primeira semana vêm delas.`)
};

const fr_fr2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les tables de référence de force diffèrent, et les charges de la première semaine en découlent.`)
};

const de_de2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Referenztabellen für Kraft unterscheiden sich, und die Gewichte der ersten Woche kommen daraus.`)
};

const it_it2_intake_why_sex_long = /** @type {(inputs: Intake_Why_Sex_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tabelle di riferimento della forza sono diverse, e i carichi della prima settimana vengono da lì.`)
};

/**
* | output |
* | --- |
* | "Strength reference tables differ, and the first-week loads come from them." |
*
* @param {Intake_Why_Sex_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_sex_long = /** @type {((inputs?: Intake_Why_Sex_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Sex_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_sex_long(inputs)
	if (locale === "es-419") return es_419_intake_why_sex_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_sex_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_sex_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_sex_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_sex_long(inputs)
	return en_us2_intake_why_sex_long(inputs)
});
export { intake_why_sex_long as "intake.why.sex.long" }